{
    "_or": "o",
    "abonoLogo": "Abonoteatro",
    "abonoTeatroInfo": "Info AbonoTeatro",
    "abonoTeatroSettings": "AbonoTeatro Ajustes",
    "accept": "Aceptar",
    "accompanying": "Acompañante",
    "accompanyingCosts": "Gastos Acompañante",
    "accompanyingPVP": "PVP Acompañante",
    "accompanyingPerSubscriber": "Acompañantes por abono",
    "accompanyingTicket": "Entrada acompañante",
    "accompanyingTickets": "Entradas acompañante",
    "accompanyingTickets_short": "Entr. Acomp.",
    "accompanying_short": "Acomp.",
    "accompanyings": "Acompañantes",
    "accompanyingsPerSubscription": "Acompañantes por abono",
    "activatedSubscriptions": "Abonos registrados",
    "activationDate": "Fecha activación",
    "active": "Activo",
    "activeSubscriberNotFound": "No se ha encontrado ningun abonado activo",
    "activeSubscriptions": "Abonos activados",
    "adaptedForDeaf": "Adaptado para sordos",
    "adaptedForDeaf_short": "Audit.",
    "adaptedForWheelchair": "Adaptado para movilidad reducida",
    "adaptedForWheelchair_short": "Mov. red.",
    "add": "Añadir",
    "addCodes": "Añadir códigos",
    "addCompany": "Añadir empresa",
    "addConfiguration": "Añadir configuración",
    "addDiscountCode": "Añadir código dto.",
    "addEnclosure": "Añadir recinto",
    "addMarket": "Añadir mercado",
    "addProduct": "Añadir producto",
    "addProducts": "Añadir productos",
    "addQuestion": "Añadir pregunta",
    "addSession": "Añadir sesión",
    "addType": "Añadir tipo",
    "addUser": "Añadir usuario",
    "addZoneAndSeats": "Añadir zona y butacas",
    "adding": "Añadiendo",
    "address": "Dirección",
    "advice": "AVISO",
    "agents_may": "Agente(s)",
    "aggregate": "Agregado",
    "aggregates": "Agregados",
    "agreements": "Acuerdos",
    "alert": "Alerta",
    "all": "Todo",
    "allEvents": "Todos los eventos",
    "allStatuses": "Todos los estados",
    "all_plural": "Todos",
    "amount": "Importe",
    "amountShorted": "Cant.",
    "answer": "Responder",
    "answeredOnDatetime": "Respondió el {{date}} {{hour}}h",
    "appName": "Abonoteatro",
    "applicableTo": "Aplicable a",
    "applicableVat": "IVA aplicable",
    "applyToManagementCosts": "¿Aplica a gastos de gestión?",
    "approve": "Aprobar",
    "article": "Artículo",
    "assessment": "Valoración",
    "assessments": "Valoraciones",
    "assignPassword": "Asignar contraseña",
    "assignToMe": "Asignarme a mí",
    "assignToMeNow": "Asignarme a mí ahora",
    "assignedToMe": "Asignadas a mí",
    "associateThisUserToOneOrMoreMarkets": "Asocia este usuario a uno o más mercados. Cada mercado admite múltiples roles.",
    "attachImage": "Adjuntar imagen",
    "attachImages": "Adjuntar imágenes",
    "authorized": "Autorizado",
    "authorizedSubscriberTicket": "Entrada Autorizado",
    "automaticRenewal": "Renovación automática",
    "automaticRenewal_short": "Renov. Aut.",
    "automaticRenewals": "Renovaciones automáticas",
    "availability": "Disponibilidad",
    "availableAtEventsInOtherMarkets": "Disponible en eventos de otros mercados",
    "averageAssessment": "Valoración media",
    "averagePrice": "Precio medio",
    "averageSubscriptionPrice": "Precio medio del abono",
    "avgTicketPrice": "Precio medio de la entrada",
    "back": "Volver",
    "basicData": "Datos básicos",
    "beneficiaries": "Beneficiarios",
    "beneficiary": "Beneficiario",
    "billing": "Facturación",
    "billing_priceBySubscriber": "Facturación (precio por abonado)",
    "birth": "Nacimiento",
    "birthday": "Fecha Nacimiento",
    "breadcrumbs": "Migas de navegación",
    "bulkEdition": "Edición masiva",
    "businessName": "Razón social",
    "buyer": "Comprador",
    "byDefault": "Por defecto",
    "cancel": "Cancelar",
    "categories": "Categorías",
    "category": "Categoría",
    "changePassword": "Cambiar contraseña",
    "changesOfLegacyData": "Modificación de datos heredados",
    "characterAlphaNumLengthLimitRange": "debería estar entre {{min}} y {{max}}",
    "characterLength": "Nº caracteres alfanum.",
    "charactersMaximum": "Caracteres máximos",
    "checkUncheckAll": "Marcar / Desmarcar todo",
    "checkUncheckAllCapabilities": "Marcar / Desmarcar todos los permisos",
    "childrenDiscount": "Descuento hijo",
    "chooseASessionToModify": "Elige una sesión para modificarla",
    "chooseASessionToModifyAdvice": "Aunque las sesiones se han creado en bloque de forma global, puedes modificar detalles específicos de cada sesión.",
    "chooseFromOneOfTheseOptions": "Escoge entre una de estas opciones",
    "cifNif": "CIF/NIF",
    "close": "Cerrar",
    "closeSidebar": "Cerrar sidebar",
    "closingReportEmails": "Emails informe cierre evento",
    "code": "Código",
    "codes": "Códigos",
    "codesGeneratedCorrectly": "Códigos generados correctamente",
    "codesImportedSuccessfully": "Los códigos se importaron correctamente",
    "codesList": "Listado de códigos",
    "codesOutOfTotalHaveBeenImported_one": "Se ha importado {{count}} código de los {{total}} totales",
    "codesOutOfTotalHaveBeenImported_other": "Se han importado {{count}} códigos de los {{total}} totales",
    "column": "Columna",
    "comment": "Comentario",
    "commercial": "Comercial",
    "commercials": "Comerciales",
    "companies": "Empresas",
    "company": "Empresa",
    "companyCreatedSuccessfully": "Empresa creada correctamente",
    "companyDeletedSuccessfully": "Empresa eliminada correctamente",
    "companyUpdatedSuccessfully": "Empresa actualizada correctamente",
    "complete_verb": "Completar",
    "completedSuccessfully": "Se ha completado correctamente",
    "concept": "Concepto",
    "conditions": "Condiciones",
    "configuration": "Configuración",
    "configure": "Configurar",
    "configureSendingReports": "Configurar envío de informes",
    "confirmThisAction": "Por favor, confirma esta acción.",
    "confirmThisOperation": "Por favor, confirma esta operación.",
    "consult": "Consutar",
    "contactEmail": "Email de contacto",
    "contactName": "Persona de contacto",
    "contactPhone": "Teléfono de contacto",
    "continue": "Continuar",
    "conversationHistory": "Histórico de la conversación",
    "copied": "Copiado",
    "copy": "Copiar",
    "corporatePromoters": "Empresas promotoras",
    "create": "Crear",
    "createAlsoIn": "Crear tambien en",
    "createCodes": "Crear códigos",
    "createSessions": "Crear sesiones",
    "createSubscription": "Crear abono",
    "createUpdateProduct": "Crear/Editar producto",
    "creatingSessions": "Creando sesiones",
    "creationDate": "Fecha de creación",
    "creationDate_short": "F. creación",
    "current": "Actual",
    "customerService": "Atención al cliente",
    "customizationOfSubscriptionNumber": "Personalización de Nº Abono",
    "dailyDispatch": "Envío diario",
    "dataPanel": "Panel de datos",
    "date": "Fecha",
    "dateCreation": "Fecha creación",
    "dateCreation_alt": "F. Creación",
    "dateFrom": "Fecha desde",
    "dateTo": "Fecha hasta",
    "deactivationDate": "Fecha de baja",
    "deactivationDate_short": "Fecha baja",
    "defineSessions": "Definir sesiones",
    "delete": "Eliminar",
    "deleteIgnoringHavingRelatedSubscriptionTypes": "Eliminar sin importar que tenga tipos de abonos relacionados",
    "deleteIndividualSessionAdvice": "¿Eliminar la sesión individual? Esta acción es definitiva, no se podrá deshacer.",
    "deleteMassiveSessionsAdvice": "¿Eliminar las sesiones seleccionadas? Esta acción es definitiva, no se podrá deshacer.",
    "delete_alt": "Quitar",
    "deletedSuccessfully": "Eliminado correctamente",
    "derived": "Derivada",
    "derivedOperations": "Operaciones derivadas",
    "description": "Descripción",
    "destinatarie": "Destinatario",
    "destinataries": "Destinatarios",
    "detail": "Detalle",
    "detailedNumberOfUses": "Nº usos detallado",
    "details": "Detalles",
    "disable": "Desactivar",
    "disabled": "Desactivado",
    "discount": "Descuento",
    "discountCode": "Código descuento",
    "discountCodeCreatedSuccessfully": "Código de descuento creado correctamente",
    "discountCodeDeletedSuccessfully": "Código de descuento eliminado correctamente",
    "discountCodeUpdatedSuccessfully": "Código de descuento actualizado correctamente",
    "discountCodes": "Códigos descuento",
    "discountCodesList": "Listado de códigos de descuento",
    "discountCodesUpdatedSuccessfully": "Códigos de descuentos actualizados correctamente",
    "discountName": "Nombre descuento",
    "discountPercentage": "Porcentaje descuento",
    "discountPercentage_short": "Porc. Desc.",
    "discountPrice": "Importe descuento",
    "discountPrice_short": "Imp. Desc.",
    "discountPromotedBy": "Descuento promocionado por",
    "discountQuantity": "Cantidad de descuentos",
    "discountQuantity_short": "Nº Dtos.",
    "discount_AMOUNT": "Descuento Fijo",
    "discount_BASE_PRICE": "Descuento Precio Base",
    "discount_PERCENTAGE": "Descuento Porcentaje",
    "discount_short": "Dto.",
    "discounts": "Descuentos",
    "dispatchByAction": "Envío según acción",
    "doYouWantToDeletePermanently": "¿Desea eliminar definitivamente?",
    "doYouWantToSendANotificationToUsersWithTicket": "¿Desea enviar una notificación a los usuarios con entrada?",
    "download": "Descargar",
    "downloadPreview": "Descargar preview",
    "downloading": "Descargando",
    "duplicate": "Duplicar",
    "duplicating": "Duplicando",
    "duration": "Duración",
    "duration_days": "Duración (días)",
    "edit": "Editar",
    "editEmail": "Editar email",
    "editPdf": "Editar PDF",
    "editRole": "Editar rol",
    "editedBy": "Editado por",
    "editedBy_female": "Editada por",
    "editedBy_male": "Editado por",
    "email": "Email",
    "emailBanner": "Banner del email",
    "emailFormat": "Formato Email",
    "emailTemplate": "Plantilla de email",
    "email_short": "Email",
    "emails": "Emails",
    "emailsGeneral": "Emails generales",
    "emailsMustBeSeparatedWithSemicolon": "Los emails deben estar separados con ;",
    "emailsSeparatedBy": "Emails separados por",
    "emptyReportingsMessage": "Actualmente no existen informes programados para este evento.",
    "enable": "Activar",
    "enabled": "Activado",
    "enclosure": "Recinto",
    "enclosureCreatedSuccessfully": "Recinto creado correctamente",
    "enclosureDeletedSuccessfully": "Recinto eliminado correctamente",
    "enclosureSeating": "Aforo del recinto",
    "enclosureType": "Tipo de recinto",
    "enclosureUpdatedSuccessfully": "Recinto actualizado correctamente",
    "enclosures": "Recintos",
    "end": "Terminar",
    "end_noun": "Fin",
    "entryDate": "Fecha de entrada",
    "erase": "Borrar",
    "errorResendsFailed": "No se han podido realizar los reenvíos",
    "errorReturnsFailed": "No se han podido realizar las devoluciones",
    "errorSendingExportByEmail": "Error al enviar la exportación por email",
    "event": "Evento",
    "eventCreatedSuccessfully": "Evento creado correctamente",
    "eventDate": "Fecha del evento",
    "eventDeletedSuccessfully": "Evento eliminado correctamente",
    "eventDetailsUrlWebsiteInfo": "<div><p>Para poder ver la página del evento se debe:</p><ul><li>- Tener un usuario en la web</li><li>- Tener al menos un abono activo</li><li>- Tener el evento publicado</li><li>- Tener sesiones disponibles</li></ul></div>",
    "eventDuration_min": "Duración del evento (min)",
    "eventEnd": "Fin Evento",
    "eventFormat": "Formato del evento",
    "eventImage": "Imagen del evento",
    "eventMerchandising": "Merchandising de evento",
    "eventName": "Nombre del evento",
    "eventPVP": "PVP del evento",
    "eventSoloInfoScope": "Lugar \"Solo info\"",
    "eventStart": "Inicio Evento",
    "eventSubtitle": "Subtítulo del evento",
    "eventTitle": "Título del evento",
    "eventUpdatedSuccessfully": "Evento actualizado correctamente",
    "events": "Eventos",
    "eventsStatus": "Estado de los eventos",
    "executeResend": "Efectuar reenvío",
    "executeReturn": "Efectuar devolución",
    "expirationDate": "Fecha expiración",
    "expirationDate_short": "F. expiración",
    "expiredSubscriptions": "Abonos caducados",
    "exportFormat": "Formato de exportación",
    "exportSelectedSessions": "Exportar sesiones marcadas",
    "exportSentByEmail": "Exportación enviada por email",
    "featured": "Destacado",
    "fieldsToBeUpdatedWillBe": "Los campos que se van a actualizar serán",
    "file": "Fichero",
    "file_sheet": "Ficha",
    "filters": "Filtros",
    "final": "Final",
    "finalSeparator": "y",
    "finish": "Finalizar",
    "firstEnclosure": "Primer recinto",
    "firstEvent": "Primer evento",
    "firstName": "Nombre",
    "fiscalAddress": "Domicilio fiscal",
    "forActualValuesYouMustSelectASingleSession": "Para conocer los valores reales debe seleccionar una única sesión",
    "forgotPassword": "Me olvidé de la contraseña",
    "formIcon": "Icono del formulario",
    "format": "Formato",
    "frequency": "Frecuencia",
    "fromTo": "Desde - Hasta",
    "gallery": "Galería",
    "gender": "Género",
    "gender_short": "Gén.",
    "generalInfo": "Info general",
    "generalRecipientsForAllReports": "Destinatarios genéricos a todos los informes",
    "generalTemplates": "Plantillas generales",
    "generals": "Generales",
    "generate": "Generar",
    "generateSessions": "Generar sesiones",
    "gift": "Regalo",
    "gifts": "Regalos",
    "goTo": "Ir a",
    "header": "Cabecera",
    "hidePassword": "Ocultar contraseña",
    "home": "Inicio",
    "hour": "Hora",
    "ifEmailIsValidThenResetPasswordWillBeSent": "Si el email '{{email}}' es correcto, en breve le llegará un correo para restaurar la contraseña",
    "image": "Imagen",
    "image_short": "Img.",
    "import": "Importar",
    "importCodes": "Importar códigos",
    "importDiscountCodes": "Importar códigos de descuento",
    "importDiscountsInBulkFromAnExternalFile": "Importa descuentos de forma masiva desde un fichero externo. Puedes importar ficheros .csv",
    "importFile": "Importar fichero",
    "inactive": "No activo",
    "incidence": "Incidencia",
    "incidenceCreatedSuccessfully": "Incidencia creada correctamente",
    "incidenceDeletedSuccessfully": "Incidencia eliminada correctamente",
    "incidenceUpdatedSuccessfully": "Incidencia actualizada correctamente",
    "incidences": "Incidencias",
    "individual": "Individual",
    "individualSession": "Sesión única",
    "individualSession_short": "Ses. única",
    "information": "Información",
    "inheritedFrom": "Heredado de",
    "internalNote": "Nota interna",
    "issuedReports": "Informes emitidos",
    "issuedSubscriptions": "Abonos emitidos",
    "language": "Idioma",
    "languages": "Idiomas",
    "lastEdit": "Última edición",
    "lastName": "Apellidos",
    "latestIncidences": "Últimas incidencias",
    "latestOperations": "Últimas operaciones",
    "leadIncidence": "Incidencia de no abonado",
    "leads": "Interesados",
    "liable": "Responsable",
    "limited": "Limitado",
    "lineBreak": "salto de línea",
    "list": "Listado",
    "loading": "Cargando",
    "loading_dots": "Cargando...",
    "login": "Acceso",
    "logo": "Logo",
    "logout": "Desconectar",
    "main": "Principal",
    "mainMarket": "Mercado principal",
    "main_short": "Prin",
    "management": "Gestión",
    "managementCompany": "Empresa gestora",
    "managementCompany_short": "Gestora",
    "managementCostShorted": "G. Gestión",
    "managementCosts": "Gastos gestión",
    "managementCosts_short": "G. Gestión",
    "managementNumber": "Número de gestión",
    "managementPanel": "Panel de gestión",
    "manualRenewals": "Renovaciones manuales",
    "market": "Mercado",
    "markets": "Mercados",
    "massive": "Masivo",
    "massiveResend": "Reenvío masivo",
    "massiveResend_1": "Reenvío masivo de abonos",
    "massiveResend_2": "Reenvío masivo de regalo de abonos",
    "massiveResend_3": "Reenvío masivo de renovación de abonos",
    "massiveTicketReturn": "Devolución masiva de entradas",
    "massiveTicketsResend": "Reenvío masivo de entradas",
    "maxAuthorizedPerSubscription": "Nº máx de autorizado por abono",
    "maxCharacters": "Máximo {{number}} caracteres",
    "maxTimeInCart": "Tiempo máx. de espera en carrito (min.)",
    "maxUsages": "Máximo de usos",
    "maxUsages_short": "Usos máx.",
    "merchandising": "Merchandising",
    "message": "Mensaje",
    "minor": "Menor",
    "minorBirthday": "Fecha nacimiento del menor",
    "minorBirthday_short": "Fecha nac. menor",
    "minorName": "Nombre del menor",
    "minorSubscriberTicket": "Entrada Menor",
    "multipleSession": "Sesión múltiple",
    "multipleSession_short": "Ses. múltiple",
    "name": "Nombre",
    "new": "Nuevo",
    "newCompany": "Nueva compañia",
    "newRole": "Nuevo rol",
    "newUser": "Nuevo usuario",
    "newsletters": "Newsletter",
    "no": "No",
    "noOptionsFound": "No se han encontrado opciones",
    "noResultsFound": "No se ha encontrado ningún resultado",
    "noStatus": "Sin estado",
    "noTemplatesYet": "Sin plantillas todavía",
    "noValue": "Sin valor",
    "nonSubscriberMessage": "Mensaje de no abonado",
    "nonSubscribersMessages": "Mensajes de no abonados",
    "notImplementYet": "Pendiente de implementar",
    "note": "Nota",
    "noteIncludedInUserEmail": "Nota incluida en el email al usuario",
    "notice": "Aviso",
    "notification": "Notificación",
    "notificationCreatedSuccessfully": "Notificación creada correctamente",
    "notificationSentToSubscriberEmail": "Notificación enviada al email del abonado",
    "notifications": "Notificaciones",
    "nrOfAccompanyings": "Nº de acompañantes",
    "nrOfAccompanyings_short": "Nº acomp.",
    "nrOfProducts": "Nº de productos",
    "nrOfProducts_short": "Nº prod.",
    "nrOfSubscribers": "Nº de abonados",
    "nrOfSubscribers_short": "Nº abon.",
    "nrOfTickets": "Nº de entradas",
    "nrOfTickets_short": "Nº entr.",
    "number": "Número",
    "numberOfCodes": "Nº de códigos",
    "numberOfSeats": "Nº de butacas",
    "numberOfSoldTickets": "Nº entradas vendidas",
    "numberOfSoldTicketsAsAccompanying": "Nº entradas vendidas como acompañante",
    "numberOfSoldTicketsAsSubscriber": "Nº entradas vendidas como abonado",
    "number_short": "Nº",
    "observations": "Observaciones",
    "ok": "Ok",
    "onceCreatedYouWillNotBeAbleToChangeThePersonalisation": "Una vez creado, no podrás modificar la personalización. Si necesitas cambiarlo crea un nuevo abono.",
    "operation": "Operación",
    "operationDate": "Fecha de operación",
    "operationDate_short": "Fecha Op.",
    "operationDatetime": "Fecha y hora de operación",
    "operationDatetime_short": "Fecha Hora Op.",
    "operationId": "ID de operación",
    "operationId_short": "ID Op.",
    "operationStatusModifiedSuccessfully": "Se ha modificado el estado de la operación",
    "operationType": "Tipo de operación",
    "operationType_short": "Tipo Op.",
    "operations": "Operaciones",
    "optional": "Opcional",
    "organization": "Organización",
    "origin": "Origen",
    "originalPrice": "Precio original",
    "page": "Página",
    "pageNotExist": "La página que buscas no existe",
    "pageNotFound": "Página no encontrada",
    "pageUpdatedSuccessfully": "Página actualizada correctamente",
    "page_short": "Pág",
    "paramIsRequired": "Parámetro {{value}} es obligatorio.",
    "parentDiscount": "Descuento padre",
    "partialRefund": "Devolución parcial",
    "password": "Contraseña",
    "passwordAssignMessage": "Una vez asignes una contraseña para tu cuenta, ya podrás acceder a la aplicación.",
    "passwordRepeat": "Repetir contraseña",
    "passwordUpdatedSuccessfully": "Contraseña actualizada correctamente",
    "paymentCode": "Código de Redsys",
    "paymentDate": "Fecha de compra",
    "paymentDatetime": "Fecha y hora de compra",
    "paymentId": "ID de compra",
    "pdfFormat": "Formato PDF",
    "pdfTemplate": "Plantilla de PDF",
    "permanent": "Permanente",
    "personalData": "Datos personales",
    "phone": "Teléfono",
    "phone_optional": "Teléfono (opcional)",
    "position_company": "Cargo",
    "postalCode": "Código postal",
    "poster": "Cartel",
    "prefix": "Prefijo",
    "previewPdf": "Previsualizar PDF",
    "previewSuccessfullyCompleted": "Previsualización realizada correctamente",
    "price": "Precio",
    "priceBase": "Importe base",
    "priceBase_short": "Imp. base",
    "priceCost": "Gastos de gestión",
    "priceCost_short": "G. Gestión",
    "priceCost_short_alt": "Gast. Gest.",
    "priority": "Prioridad",
    "privateNote": "Nota privada",
    "producer": "Productora",
    "product": "Producto",
    "products": "Productos",
    "productsNotFound": "No se han encontrado productos",
    "province": "Provincia",
    "public": "Público",
    "purchaseRenovationDate": "Fecha compra/renovación",
    "pushNotification": "Notificación Push",
    "quantity": "Cantidad",
    "quantity_short": "Cant.",
    "question": "Pregunta",
    "receivers": "Destinatarios",
    "recipient": "Destinatario",
    "recipients": "Destinatarios",
    "recipientsAutomaticallyAddedToAllReports": "Destinatarios añadidos automáticamente a todos los informes",
    "recoverEventCapacity": "Recuperar aforo",
    "redeemTicketOfficeWatermark": "Marca de agua 'Canjeo en taquilla'",
    "refundAmount": "Devolver importe",
    "refunded": "Devuelto",
    "refunded_fem": "Devuelta",
    "refundeds": "Devueltos",
    "refundeds_fem": "Devueltas",
    "registrationDate": "Fecha de alta",
    "registrationDate_short": "Fecha alta",
    "registrationFees": "Gastos de registro",
    "relatedDiscounts": "Descuentos vinculados",
    "rememberMeOnThisComputer": "Recordarme en este ordenador",
    "rememberUser": "Recordar usuario",
    "removeConfiguration": "Quitar configuración",
    "renewable": "Renovable",
    "report": "Informe",
    "reportEmails": "Emails de reportes",
    "reports": "Informes",
    "reportsUpdatedSuccessfully": "Informes actualizados correctamente",
    "requiredFor": "Requerido para",
    "resend": "Reenviar",
    "resendCouldNotBeDone": "No se ha podido realizar el reenvío",
    "resendSuccessfully": "Reenvío realizado con éxito",
    "resendToNewEmail": "Reenviar a un email diferente (opcional)",
    "resend_1": "Reenvío de abono",
    "resend_2": "Reenvío de regalo de abono",
    "resend_3": "Reenvío de renovación de abono",
    "resend_6": "Reenvío de entrada",
    "responsible": "Responsable",
    "return": "Devolver",
    "returnCouldNotBeDone": "No se ha podido realizar la devolución",
    "returnSuccessfully": "Devolución realizado con éxito",
    "return_1": "Devolución de abono",
    "return_2": "Devolución de regalo de abono",
    "return_3": "Devolución de renovación de abono",
    "return_6": "Devolución de entrada",
    "return_noun": "Devolución",
    "returns": "Devoluciones",
    "reviewSessions": "Revisar sesiones",
    "role": "Rol",
    "roles": "Roles",
    "rolesForThisMarket": "Roles para este mercado",
    "rowsPerPage": "Filas por página",
    "saleDate": "Fecha de venta",
    "saleDateFrom": "Fecha de venta desde",
    "saleDateTo": "Fecha de venta hasta",
    "saleDays": "Días de venta",
    "salesFrom": "Ventas desde",
    "salesReportEmails": "Emails informe ventas",
    "salesTo": "Ventas hasta",
    "save": "Guardar",
    "savedSuccessfully": "Guardado correctamente",
    "savingSessions": "Guardando sesiones",
    "score": "Puntuación",
    "search": "Buscar",
    "searchSubscriber": "Buscar abonado",
    "search_dots": "Buscar...",
    "seating": "Aforo",
    "seatingAT": "Aforo Abonoteatro",
    "seatingTemplate": "Plantilla del aforo",
    "seatingsAndPrices": "Aforo y precios",
    "section": "Sección",
    "seeCodes": "Ver códigos",
    "seeEnclosureDetails": "Ver ficha del recinto",
    "seeFile": "Ver fichero",
    "seeFile_sheet": "Ver ficha",
    "seeTags": "Ver etiquetas",
    "select": "Seleccionar",
    "selectAll": "Seleccionar todas",
    "selectAllMarkets": "Selecionar todos los mercados",
    "selectAllSameOperations": "Seleccionar todas las operaciones del mismo tipo",
    "selectAllSessionsAdvice": "Debes seleccionar al menos una sesión para asignarle la configuración.",
    "selectAllSessionsWithoutTemplates": "Seleccionar todas las sesiones sin plantillas",
    "selectDefault": "Selecciona una opción",
    "selectedRows_one": "{{count}} fila seleccionada",
    "selectedRows_other": "{{count}} filas seleccionadas",
    "send": "Enviar",
    "sendAndClose": "Enviar y cerrar",
    "sendByAction": "Enviar según acción",
    "sendByHour": "Enviar a hora determinada",
    "sendCopyToSubscriberEmail": "Enviar copia al email del abonado",
    "sendSMS": "Enviar SMS",
    "sendSmsCounter": "Envío de {{count}} SMS",
    "sendingFrequency": "Frecuencia de envío",
    "separatedByCommas": "Separados por comas *",
    "separator": ",",
    "session": "Sesión",
    "sessionAlreadyHasTicketConfigAndAllowedTickets": "La sesión ya tiene configuración de entrada y códigos disponibles",
    "sessionDate": "Día sesión",
    "sessionDay": "Día de la sesión",
    "sessionExpired": "La sesión ha expirado",
    "sessionFinishByAction": "Cierre de sesión según acción",
    "sessionFinishByDatetime": "Cierre de sesión según fecha y hora",
    "sessionFinishByHour": "Cierre de sesión según hora",
    "sessionFrom": "Sesión desde",
    "sessionHasNoTemplate": "La sesión no tiene una plantilla",
    "sessionHasNoTicketCodesAndTemplates": "Configuración incompleta (códigos y plantillas obligatorios)",
    "sessionHour": "Hora de la sesión",
    "sessionSaved": "Sesión guardada",
    "sessionStatus": "Estado de la sesión",
    "sessionTo": "Sesión hasta",
    "session_plural": "Sesiones",
    "session_singular": "Sesión",
    "sessions": "Sesiones",
    "sessionsCalendar": "Calendario de sesiones",
    "sessionsEndDate": "Fecha fin sesiones",
    "sessionsNumber": "Número de sesiones",
    "sessionsNumber_short": "Nº sesiones",
    "sessionsSaved": "Sesiones guardadas",
    "sessionsStartDate": "Fecha inicio sesiones",
    "settings": "Ajustes",
    "settlementByAccompanyingTicket": "Liquidación por entrada de acompañante",
    "settlementBySubscriberTicket": "Liquidación por entrada de abonado",
    "settlementEmails": "Emails financiero",
    "settlements": "Liquidaciones",
    "shortDescription": "Descripción corta",
    "showDatetimeFields": "Mostrar campos de fecha y hora",
    "showOnlyWithErrors": "Mostrar solo con errores",
    "showPassword": "Mostrar contraseña",
    "sidebar": "Sidebar",
    "sold": "Vendido",
    "soldSubscriptions": "Abonos vendidos",
    "soldUnits": "Unidades vendidas",
    "sold_fem": "Vendida",
    "solds": "Vendidos",
    "solds_fem": "Vendidas",
    "sorry": "Lo siento",
    "specificRecipients": "Destinatarios específicos",
    "specificTimeDispatch": "Envío a hora determinada",
    "start": "Iniciar",
    "startOfSaleSetForMoreThanAYearFromNow": "Inicio de la venta configurada para dentro de más de un año.",
    "start_noun": "Inicio",
    "status": "Estado",
    "stock": "Stock",
    "suboperation_short": "Sub",
    "subscriber": "Abonado",
    "subscriberCosts": "Gastos Abonado",
    "subscriberEmail": "Email abonado",
    "subscriberInformation": "Información del abonado",
    "subscriberName": "Nombre del abonado",
    "subscriberNumber": "Número de abonado",
    "subscriberNumber_short": "Nº Abonado",
    "subscriberPVP": "PVP Abonado",
    "subscriberPrice": "Precio abonado",
    "subscriberTicket": "Entrada Abonado",
    "subscriberTickets": "Entradas Abonado",
    "subscriberTickets_short": "Entr. Abon.",
    "subscriberUpdatedSuccessfully": "Abonado actualizado correctamente",
    "subscribers": "Abonados",
    "subscribersEmails": "Emails abonados",
    "subscription": "Abono",
    "subscriptionCreatedSuccessfully": "Abono creado correctamente",
    "subscriptionData": "Datos del abono",
    "subscriptionDeletedSuccessfully": "Abono eliminado correctamente",
    "subscriptionExpenses": "Gastos del abono",
    "subscriptionExpenses_resume": "Abono - Gastos",
    "subscriptionNumber": "Número de abono",
    "subscriptionNumber_short": "Nº abono",
    "subscriptionPrice": "Precio del abono",
    "subscriptionPrice_resume": "Abono - Precio",
    "subscriptionRevenueWithExpenses": "Ingresos por abono con gastos",
    "subscriptionRevenues": "Ingresos por abono",
    "subscriptionType": "Tipo de abono",
    "subscriptionTypeCreatedSuccessfully": "Tipo de abono creado correctamente",
    "subscriptionTypeDeletedSuccessfully": "Tipo de abono eliminado correctamente",
    "subscriptionTypeUpdatedSuccessfully": "Tipo de abono actualizado correctamente",
    "subscriptionTypes": "Tipos de abonos",
    "subscriptionUpdatedSuccessfully": "Abono actualizado correctamente",
    "subscriptions": "Abonos",
    "subscriptionsQuantity": "Cantidad de abonos",
    "subscriptionsUpdatedSuccessfully": "Abonos actualizados correctamente",
    "subscriptionsWillBeResent_one": "Se reenviará {{count}} abono",
    "subscriptionsWillBeResent_other": "Se reenviarán {{count}} abonos",
    "subtitle": "Subtítulo",
    "subtotal": "Subtotal",
    "successResendsInProgress": "Se están realizando los reenvíos en segundo plano",
    "successReturnsInProgress": "Se están realizando las devoluciones en segundo plano",
    "suitableForMinors": "Apto para todos los públicos",
    "supportEmail": "Email de contacto",
    "supportName": "Persona de contacto",
    "supportPhone": "Teléfono de contacto",
    "synopsys": "Sinopsis",
    "tags": "Etiquetas",
    "template": "Plantilla",
    "templateCreated": "Plantilla creada correctamente",
    "templateDeleted": "Plantilla eliminada correctamente",
    "templateDuplicated": "Plantilla duplicada correctamente",
    "templateName": "Nombre de la plantilla",
    "templateUpdated": "Plantilla actualizada correctamente",
    "testEmail": "Email de prueba",
    "testEmailSuccessfullySent": "Email de prueba enviado correctamente",
    "thereAreCurrentlyNoReports": "Actualmente no existen informes programados para este recinto.",
    "thereAreSessionsWithoutCodes": "Hay sesiones sin códigos",
    "thereAreSessionsWithoutCodes_one": "Hay {{count}} sesión sin códigos",
    "thereAreSessionsWithoutCodes_other": "Hay {{count}} sesiones sin códigos",
    "thereIsNoUpdatedFields": "Solo se guardarán los datos editados. Por favor, edite los campos deseados para actualizar las sesiones",
    "thisActionCannotBeUndone": "Esta acción no se podrá deshacer",
    "ticket": "Entrada",
    "ticketCode": "Código de entrada",
    "ticketCode_short": "Cód. Entrada",
    "ticketExpenses": "Gastos Entrada",
    "ticketExpenses_resume": "Entrada - Gastos",
    "ticketOfficeHours": "Horario taquilla",
    "ticketPrice": "Precio entrada",
    "ticketPrice_resume": "Entrada - Precio",
    "ticketType": "Tipo de entrada",
    "ticketWillBeModified_one": "Se modificará {{count}} entrada",
    "ticketWillBeModified_other": "Se modificarán {{count}} entradas",
    "tickets": "Entradas",
    "ticketsConfig": "Config. Entradas",
    "ticketsConfigUpdatedSuccessfully": "Configuración de entradas actualizada correctamente",
    "ticketsFormat": "Formato de entradas",
    "ticketsGeneration": "Generación de entradas",
    "ticketsWillBeModified_one": "Se modificará {{count}} entrada",
    "ticketsWillBeModified_other": "Se modificarán {{count}} entradas",
    "ticketsWillBeResent_one": "Se reenviará {{count}} entrada",
    "ticketsWillBeResent_other": "Se reenviarán {{count}} entradas",
    "total": "Total",
    "totalIncome": "Ingresos totales",
    "totalManageCosts": "Total gastos de gestión",
    "totalRefund": "Devolución total",
    "totalRenewals": "Total renovaciones",
    "totalTicketsPerOperation": "Entradas totales por operación",
    "totalUses": "Total de usos",
    "totalWithManagementExpenses": "Total con gastos gestión",
    "totalWithoutManagementExpenses": "Total sin gastos gestión",
    "totals": "Totales",
    "township": "Localidad",
    "type": "Tipo",
    "unassigned": "Sin asignar",
    "updatePassword": "Actualizar contraseña",
    "updateSalesReport": "Actualizar informe de ventas",
    "updateSubscription": "Editar abono",
    "updatedSuccessfully": "Actualizado correctamente",
    "updatedSuccessfully_plural": "Actualizados correctamente",
    "upload": "Subir",
    "uploadNewImage": "Subir nueva imagen",
    "user": "Usuario",
    "userCreatedSuccessfullyAndEmailSended": "Usuario creado con éxito y enviado correo para confirmar contraseña",
    "userEmail": "Email de usuario",
    "userManagement": "Gestión de usuarios",
    "userName": "Nombre de usuario",
    "userUpdatedSuccessfully": "Usuario actualizado correctamente",
    "users": "Usuarios",
    "valid": "Válido",
    "validFrom": "Válido desde",
    "validUntil": "Válido hasta",
    "valid_current": "Vigente",
    "validate": "Validar",
    "validated": "Validado",
    "validated_short": "Val.",
    "verified": "Verificado",
    "viewMainOperationDetails": "Ver operación inicial",
    "viewOperationDetails": "Ver detalles de la operación",
    "viewRenovateDetails": "Ver detalles de la renovación",
    "weAreSorry": "Lo sentimos",
    "webEdition": "Edición web",
    "webLink": "Enlace web",
    "webMessages": "Mensajes web",
    "webNotification": "Notificación web",
    "webpages": "Páginas web",
    "website": "Website",
    "websiteUpdatedSuccessfully": "Website actualizada correctamente",
    "withNews": "Con novedades",
    "wouldYouLikeToReturnTheTickets": "¿Desea realizar una devolución de las entradas?",
    "wroteOnDatetime": "Escribió el {{date}} {{hour}}h",
    "yes": "Si",
    "youAreGoingToCompleteThisPurchase": "Vas completar la compra de esta operación.",
    "youAreGoingToMakeARefund_one": "Vas a efectuar una devolución de {{amount}}.",
    "youAreGoingToMakeARefund_other": "Vas a efectuar una devolución de {{amount}}.",
    "youAreGoingToMakeARefund_zero": "No vas a efectuar ninguna devolución de importe.",
    "youAreGoingToMakeASubscriptionResend_one": "Vas a efectuar un reenvío de {{count}} abono.",
    "youAreGoingToMakeASubscriptionResend_other": "Vas a efectuar un reenvío de {{count}} abonos.",
    "youAreGoingToMakeATicketResend_one": "Vas a efectuar un reenvío de {{count}} ticket.",
    "youAreGoingToMakeATicketResend_other": "Vas a efectuar un reenvío de {{count}} tickets.",
    "youAreGoingToUpdateCapacity_one": "Vas a recuperar el aforo de {{count}} asiento.",
    "youAreGoingToUpdateCapacity_other": "Vas a recuperar el aforo de {{count}} asientos.",
    "youAreGoingToUpdateCapacity_zero": "No vas a recuperar el aforo.",
    "youAreGoingToUpdateReport_one": "Vas a actualizar los informes de ventas.",
    "youAreGoingToUpdateReport_zero": "No vas a actualizar los informes de ventas.",
    "youAreGoingToUpdateSubscription_one": "Vas a actualizar {{quantity}} abono.",
    "youAreGoingToUpdateSubscription_other": "Vas a actualizar {{quantity}} abonos.",
    "youAreGoingToUpdateSubscription_zero": "No vas a actualizar ningún abono.",
    "youtubeVideo": "Vídeo en Youtube",
    "zone": "Zona",

    "confirmDialog": {
        "title": "Confirmar acción",
        "content": "¿Desea eliminar definitivamente {{deleteDescription}}",
        "roleDescription": "Se eliminará este rol de todos los usuarios que lo tengan asignado.",
        "role": "el rol {{roleName}}?",
        "company": "la empresa: {{companyName}}?",
        "enclosure": "el recinto: {{enclosureName}}?",
        "discount": "el descuento {{discountName}}?",
        "event": "el evento {{name}}?",
        "definitiveAction": "Esta acción no se podrá deshacer.",
        "incidence": "la incidencia {{codeNumber}}?",
        "subscriptionType": "el tipo de abono {{subscriptionType}}?"
    }
}
